<div class="page-wrapper section-hr-direct">
    <app-left-menu [showMenu]="false"></app-left-menu>

    <div id="main-container">

        <app-header [showHistoryButton]="true" [showAddLicense]="true" [title]="title"></app-header>
        <div style="height: 40px;display: block;">&nbsp;</div>
        <div class="page-content">

            <div class="content-header" style="margin-top: 70px;clear: both;">

                <ul class="nav nav-tabs content" role="tablist">
                    <li role="presentation" class="active"><a href="#activeLicenses" role="tab" data-toggle="tab"
                            aria-expanded="true">{{'Common.Headers.Current' | translate}}
                        </a>
                    </li>
                    <li role="presentation"><a href="#inActiveLicenses" role="tab" data-toggle="tab"
                            aria-expanded="false">{{'Common.Headers.Past' | translate}}</a>
                    </li>
                </ul>
            </div>
            <div class="tab-content">
                <div role="tabpanel" class="tab-pane active" id="activeLicenses">

                    <!--<div id="{{(year.FullDate | date:'MM') +'_'+(year.FullDate | date:'y')}}"></div>-->

                    <table *ngIf="activeLicenses?.length>0" style="font-size: 13px;" class="table table-bordered"
                        id="table">
                        <thead>
                            <tr>
                                <th style="word-break: break-all;"> {{'License.Table.Header.Name' | translate}}
                                </th>
                                <th style="word-break: break-all;">
                                    {{'License.Table.Header.Number' | translate}}</th>
                                <th style="word-break: break-all;"> {{'License.Table.Header.Type'| translate}}
                                </th>

                                <th style="word-break: break-all;">
                                    {{'License.Table.Header.ExpiryDate' | translate}}</th>
                                <th style="word-break: break-all;"> {{'License.Table.Header.State' | translate}}
                                </th>
                                <th style="word-break: break-all;">
                                    {{'License.Table.Header.Attachments'| translate}}</th>
                                <th style="text-align: center;"> {{'Common.Action'| translate}}</th>

                            </tr>
                        </thead>
                        <tbody>

                            <tr [class.alternate]="i%2!=0" *ngFor="let item of activeLicenses; index as i;">

                                <td style="width: 200px;">{{item.LicenseName}}</td>
                                <td style="width: 200px;">{{item.LicenseNumber}}</td>
                                <td style="width: 200px;">{{item.LicenseType}}</td>
                                <td style="width: 200px;">{{item.LicenseExpiryDate | date:'MM/dd/yyyy'}}</td>
                                <td style="width: 200px;">{{item.LicenseState}}</td>
                                <td style="width: 200px;"><a [routerLink]="['/viewattachment',attachment.Id]"
                                        routerLinkActive="router-link-active" style="display: block;"
                                        *ngFor="let attachment of item.Attachments">
                                        {{attachment.FileName}}
                                    </a></td>

                                <td style="width: 50px;text-align: center;"><a
                                        [routerLink]="['edit',item.LicenseId]"
                                        routerLinkActive="router-link-active" class="icon edit round"
                                        href="javascript:void(0)"></a></td>
                            </tr>
                        </tbody>
                    </table>
                    <div class="not-found" *ngIf="activeLicenses?.length==''">
                        {{'License.NoRecord.Active'|translate}}
                    </div>

                </div>
                <div role="tabpanel" class="tab-pane " id="inActiveLicenses">

                    <!--<div id="{{(year.FullDate | date:'MM') +'_'+(year.FullDate | date:'y')}}"></div>-->

                    <table *ngIf="inActiveLicenses?.length>0" style="font-size: 13px;" class="table table-bordered"
                        id="table">
                        <thead>
                            <tr>
                                <th style="word-break: break-all;"> {{'License.Table.Header.Name' | translate}}
                                </th>
                                <th style="word-break: break-all;">
                                    {{'License.Table.Header.Number' | translate}}</th>
                                <th style="word-break: break-all;"> {{'License.Table.Header.Type'| translate}}
                                </th>

                                <th style="word-break: break-all;">
                                    {{'License.Table.Header.ExpiryDate' | translate}}</th>
                                <th style="word-break: break-all;"> {{'License.Table.Header.State' | translate}}
                                </th>
                                <th style="word-break: break-all;">
                                    {{'License.Table.Header.Attachments'| translate}}</th>
                                <th style="text-align: center;"> {{'Common.Action'| translate}}</th>

                            </tr>
                        </thead>
                        <tbody>

                            <tr [class.alternate]="i%2!=0" *ngFor="let item of inActiveLicenses; index as i;">

                                <td style="width: 200px;">{{item.LicenseName}}</td>
                                <td style="width: 200px;">{{item.LicenseNumber}}</td>
                                <td style="width: 200px;">{{item.LicenseType}}</td>
                                <td style="width: 200px;">{{item.LicenseExpiryDate | date:'MM/dd/yyyy'}}</td>
                                <td style="width: 200px;">{{item.LicenseState}}</td>
                                <td style="width: 200px;"><a [routerLink]="['//viewattachment',attachment.Id]"
                                        routerLinkActive="router-link-active" style="display: block;"
                                        *ngFor="let attachment of item.Attachments">
                                        {{attachment.FileName}}
                                    </a></td>

                                <td style="width: 50px;text-align: center;"><a
                                        [routerLink]="['edit',item.LicenseId]"
                                        routerLinkActive="router-link-active" class="icon edit round"
                                        href="javascript:void(0)"></a></td>
                            </tr>
                        </tbody>
                    </table>
                    <div class="not-found" *ngIf="inActiveLicenses?.length<=0">
                        {{'License.NoRecord.Inactive'|translate}}
                    </div>


                </div>

            </div>
        </div>
    </div>
</div>